export default __webpack_public_path__ + "static/campus-map-ace9804500ede754cb4a0fa88d5400cc.png";